import { Box, Slider, styled } from '@mui/material';

export const SliderBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ compact }) => ({
  marginTop: compact ? '20px' : '18px',
  padding: compact ? '0 2px' : '0 6px',
}));

// Styled MUI Slider — rail/track/thumb/mark repainted to match the design's
// custom look (gradient fill, gold-ring thumb, segmented dots) while keeping
// MUI's built-in drag/keyboard/ARIA handling for free.
export const StyledTrack = styled(Slider)(({ theme }) => ({
  height: 8,
  padding: '13px 0',
  color: theme.palette.primary.main,
  '& .MuiSlider-rail': {
    height: 8,
    borderRadius: 999,
    backgroundColor: '#dde4eb',
    opacity: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.action.hover,
    }),
  },
  '& .MuiSlider-track': {
    height: 8,
    borderRadius: 999,
    border: 'none',
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, #3a6ea8)`,
    transition: 'width .12s ease-out, left .12s ease-out',
  },
  '& .MuiSlider-thumb': {
    width: 26,
    height: 26,
    backgroundColor: '#fff',
    border: '3px solid #F5B300',
    boxShadow: '0 2px 8px rgba(20,57,92,.22)',
    transition: 'left .12s ease-out',
    '&:hover, &.Mui-focusVisible': {
      boxShadow: '0 0 0 4px rgba(246,178,27,.35)',
    },
    '&.Mui-active': {
      boxShadow: '0 0 0 4px rgba(246,178,27,.35)',
    },
  },
  '& .MuiSlider-mark': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#c3ced8',
    opacity: 1,
  },
  '& .MuiSlider-markActive': {
    backgroundColor: 'rgba(255,255,255,.8)',
    opacity: 1,
  },
}));
